/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notetaker_Issue_Failed_BodyInputs */



/**
* | output |
* | --- |
* | "Something went wrong on our side, so Wundo could not record this conversation." |
*
* @param {Meeting_Notetaker_Issue_Failed_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notetaker_issue_failed_body = /** @type {((inputs?: Meeting_Notetaker_Issue_Failed_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notetaker_Issue_Failed_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er liep iets mis aan onze kant, waardoor Wundo dit gesprek niet kon opnemen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Un problème est survenu de notre côté, donc Wundo n'a pas pu enregistrer cette conversation.")
	return /** @type {LocalizedString} */ ("Something went wrong on our side, so Wundo could not record this conversation.")
});